import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import {
  MAT_CHECKBOX_DEFAULT_OPTIONS,
  MatCheckboxDefaultOptions,
} from '@angular/material/checkbox';
import {
  DownloadManagerService,
  downloadErrorObserver,
  downloadFinishedObserver,
  downloadProgressObserver,
  fileRemovedObserver,
} from 'src/app/shared/services/download-manager-service';
import { DriveFile } from '../drive-file';
import { DRIVE_MANAGED_FOLDER_NAME } from '../../../../../shared/consts/strings';

@Component({
  selector: 'app-file-list-view',
  templateUrl: './file-list-view.component.html',
  styleUrls: ['./file-list-view.component.scss'],
  providers: [
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions,
    },
  ],
})
export class FileListViewComponent implements AfterViewInit {
  @Input() file: DriveFile;
  @Input() selected: boolean = false;
  @Input() focus: boolean = false;
  @Input() isSelectingMode: boolean = false;

  protected errorHappened: boolean = false;
  protected progress: number = 0;

  @Output() readonly navigate: EventEmitter<DriveFile> = new EventEmitter();

  constructor(private el: ElementRef, private downloadManager: DownloadManagerService) {
    downloadProgressObserver.subscribe((fileManagerType) => {
      if (fileManagerType.file === this.file) {
        this.errorHappened = false;
        this.progress = fileManagerType.progress;
      }
    });

    downloadFinishedObserver.subscribe((fileManagerType) => {
      if (fileManagerType.file === this.file) {
        this.errorHappened = false;
        this.progress = 0;
      }
    });

    downloadErrorObserver.subscribe((error) => {
      if (error.file.rawData === this.file) {
        this.errorHappened = true;
      }
    });

    fileRemovedObserver.subscribe((fileManagerType) => {
      if (fileManagerType.file === this.file) this.progress = 0;
    });
  }

  private calcExistingProgress(): void {
    let fileManagerType = this.downloadManager
      .getFileList()
      .find((fileManagerType) => fileManagerType.file === this.file);
    if (fileManagerType && fileManagerType.progress < 100) {
      this.progress = fileManagerType.progress;
      this.errorHappened = fileManagerType.isError();
    }
  }

  public onNavigate() {
    this.navigate.emit();
  }

  ngAfterViewInit() {
    if (this.focus) {
      setTimeout(() => {
        this.el.nativeElement.querySelectorAll('.file-name').forEach((el) => {
          el.scrollIntoView({
            // behavior: 'smooth',
            block: 'center',
          });
        });
      }, 1);
    }

    this.calcExistingProgress();
  }

  protected readonly DRIVE_MANAGED_FOLDER_NAME = DRIVE_MANAGED_FOLDER_NAME;
}
